<template>
    <div class="row">
        <div class="col-12">
            <div class="card mb-1 p-0">
                <div class="card-body pb-0" >
                    <div class=" col-12 mb-3">
                        <label><i class="fas fa-search color-theme mr-1"></i><span class="font-17"> Pesquisar por tema: </span></label>
                        <v-select title="Desktop" :options="[{'value': 0, 'desc': 'Todos'},{'value': 1, 'desc': 'Dados cadastrais'}, {'value': 2, 'desc': 'Suas preferências'}, {'value': 3, 'desc': 'Diagnóstico do nível de estresse'}, {'value': 4, 'desc': 'Diagnóstico de estudo espiritual das pessoas'},{'value': 5, 'desc': 'Avaliação da vida'}]" label="desc" v-model="criar.tela" @change="updatePage" />
                        <select title="Mobile" class="form-control" v-model="criar.tela" @change="updatePage">
                            <option v-for="(option, index) in [{'value': 0, 'desc': 'Todos'},{'value': 1, 'desc': 'Dados cadastrais'}, {'value': 2, 'desc': 'Suas preferências'}, {'value': 3, 'desc': 'Diagnóstico do nível de estresse'}, {'value': 4, 'desc': 'Diagnóstico de estudo espiritual das pessoas'},{'value': 5, 'desc': 'Avaliação da vida'}]" :key="index" :value="option.value">{{ option.desc }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="mt-2" v-if="resultado.length != 0">
                <div class="pb-0" >
                    <div class="card " v-for="resultados in resultado" :key="resultados.pergunta">
                        <div class="col-12 mb-2 mt-2 rounded align-center justify-content-center">
                            <h5 class="">{{resultados.pergunta}}</h5>
                            <p class="mb-3 mt-3">Tipo: {{resultados.tipo}}</p>
                            <div class="d-flex align-center justify-content-center">
                                <div>
                                    <button type="button" class="btn btn-outline-light" @click="editar(resultados)">Editar</button>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-outline-light" @click="deletar(resultados.id)">Excluir</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="modalChannel" tabindex="-1" aria-labelledby="modalChannelLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title h4" id="modalChannelLabel">Editar pergunta</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="card-body pb-0" >
                                    <div class="row">
                                        <div class="col">
                                            <div class="col-12 mb-3">
                                                <label><i class="fas fa-question-circle color-theme mr-1"></i><span class="font-17"> Sua pergunta:</span></label>
                                                <input  type="text" class="form-control required" maxlength="200"  placeholder="Coloque sua pergunta aqui" v-model="pgtEditar.pergunta" />  
                                            </div>
                                            <div class="col-12">
                                                <label><i class="fas fa-th-large color-theme mr-1"></i><span class="font-17"> Forma de resposta: </span></label>
                                                <v-select title="Desktop" :options="['Dissertativa', 'Alternativa', ]" v-model="pgtEditar.tipo" />
                                                <select title="Mobile" class="form-control" v-model="pgtEditar.tipo">
                                                    <option v-for="(option, index) in ['Dissertativa', 'Alternativa',]" :key="index" :value="option">{{ option }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <transition name="slide-up  ">
                                            <div class="row p-0 mb-2 p-3" v-if="pgtEditar.tipo == 'Alternativa' || pgtEditar.tipo == 'Alternativa multipla escolha'">
                                                <div class="col-12 mt-2" v-for="(alternativa, index) in pgtEditar.listaAlternativa" :key="index">
                                                    <div class="d-flex justify-content-between align-items-center">
                                                        <label><i class="fas fa-list color-theme mr-1"></i><span class="font-17"> Sua alternativa:</span></label>
                                                        <label class="container_marker">
                                                            <input type="checkbox" checked="checked" v-model="alternativa.habilitaDescritiva">
                                                            <div class="checkmark"></div>
                                                        </label>
                                                        <!-- <div class="cntr d-flex">
                                                            <i class="fas fa-text color-theme mr-2 font-16 text-icon"></i>
                                                            <input type="checkbox" class="hidden-xs-up new_cbx" v-model="alternativa.habilitaDescritiva"/>
                                                            <label class="cbx"></label>
                                                        </div> -->
                                                    </div>
                                                    <div class="">
                                                        <input type="text" class="form-control required" maxlength="200" v-model="alternativa.alternativa" placeholder="Opção aqui"/>
                                                    </div>
                                                </div>
                                                <div class="col mt-3" v-if="travaBtn >= 1 && travaBtn < 15">
                                                    <button class=" btn btn-secondary w-100 rounded font-weight-bold" @click="adicionarOpcao()">
                                                        <i class="fas fa-plus font-13  mr-1 "></i> Adicionar
                                                    </button>
                                                </div>
                                                <div class="col mt-3" v-if="travaBtn > 1">
                                                    <button class=" btn btn-secondary w-100 rounded font-weight-bold" @click="removerOpcao()">
                                                        <i class="fas fa-minus font-13 mr-1"></i> Remover
                                                    </button>
                                                </div>
                                            </div>
                                        </transition>
                                        <div class="col-12">
                                            <button type="button" class="btn btn-secondary w-100 mt-2 mb-3" @click="enviar()">
                                                <span class="font-17 font-weight-bold"><i class="fas fa-save mr-1"></i>SALVAR</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            <div class="d-flex justify-content-center align-items-center mt-4" v-else>
                <span>Não existem perguntas cadastradas</span>
            </div>
        </div>
    </div>
</template>


<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
	name: 'EditarPerguntas',
    data() {
        return {
            criar: {
                tela: 0,
                pergunta: '',
                formaResposta: '',
                alternativas: [
                    {opcao: null, habilitaDescritiva: false},
                ],
                id:'',
            },
            pgtEditar: {},
            resultado: [],
            travaBtn: 1,
        };
    },
    watch() {

    },
    mounted() {
        this.criar.tela = this.criar.tela != null ? this.criar.tela : 0;
        this.resultado = [];
            let ref = this;
            this.$axios({
                method: 'get',
                url: this.urlRest +'service/getPergunta',
                params: {
                    tela: this.criar.tela,
                },
                headers: {
                    'Content-Type': 'application/json'
                },

            }).then(response => {
				ref.resultado = response.data;
                console.log(response.data)

            }).catch(function (error) {
                if (error.response != undefined) {
                    if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                            icon: 'warning',
                            title: 'Sessão expirada!'
                        });
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: 'Erro: ' + error.response.status
                        })
                    }
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: error
                        })
                    }
                }).finally(() => {
                    this.$store.dispatch('alternarTelaCarregamento', false);
                }); 
    },
    computed: {
      ... mapState({
         urlRest: state => state.urlRest
      })
    },
    methods: {
        updatePage() {
            this.criar.tela = this.criar.tela != null ? this.criar.tela : 0;
            this.resultado = [];
                let ref = this;
                this.$axios({
                    method: 'get',
                    url: this.urlRest +'service/getPergunta',
                    params: {
                        tela: this.criar.tela,
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    },

                }).then(response => {
                    ref.resultado = response.data;

                }).catch(function (error) {
                    if (error.response != undefined) {
                        if (error.response.status == 408) {
                            ref.$store.dispatch('deslogar')

                            ref.$toast.fire({
                                icon: 'warning',
                                title: 'Sessão expirada!'
                            });
                        } else {
                            ref.$toast.fire({
                                icon: 'error',
                                title: 'Erro: ' + error.response.status
                            })
                        }
                        } else {
                            ref.$toast.fire({
                                icon: 'error',
                                title: error
                            })
                        }
                    }).finally(() => {
                        this.$store.dispatch('alternarTelaCarregamento', false);
                    }); 
        },
        editar : function (resultados) {
            this.pgtEditar = resultados
            $('#modalChannel').modal('show')
        },
        deletar : function (id) {
            let ref = this;
            Swal.fire({
                icon: 'warning',
                title: 'Tem certeza que deseja deletar essa pergunta?',
                confirmButtonText: 'Confirmar',
                showCancelButton: true,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    ref.$axios({
                        method: 'post',
                        url: this.urlRest +'service/deletePergunta',
                        params: {
                            idPergunta: id,
                        },
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: this.pgtEditar
                    }).then(() => {
                        ref.updatePage()
                    })
                    
                }
            })
        },
        adicionarOpcao() {
            this.pgtEditar.listaAlternativa.push({ alternativa: null , habilitaDescritiva: false});
            this.travaBtn += 1
        },
        removerOpcao() {
            this.pgtEditar.listaAlternativa.pop();
            this.travaBtn -= 1
        },
        enviar() {
            let ref = this;
            
            ref.criar.id = ref.pgtEditar.id
            this.$axios({
                method: 'post',
                url: this.urlRest +'service/editPergunta',
                headers: {
                    'Content-Type': 'application/json'
                },

                data: this.pgtEditar
            }).then(function () {
                ref.$toast.fire({
                    icon: 'success',
                    title: 'Pergunta alterada!',
                    timer: 2000,
                }),
                $('#modalChannel').modal('hide')
            }).catch(function (error) {
                if (error.response != undefined) {
                    if (error.response.status == 408) {
                        ref.$store.dispatch('deslogar')

                        ref.$toast.fire({
                            icon: 'warning',
                            title: 'Sessão expirada!'
                        });
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: 'Erro: ' + error.response.status
                        })
                    }
                    } else {
                        ref.$toast.fire({
                            icon: 'error',
                            title: error
                        })
                    }
                }).finally(() => {
                    this.$store.dispatch('alternarTelaCarregamento', false);
                });
                this.criar         
        },

    },
    beforeDestroy() {
      window.removeEventListener('resize', this.checkWindowSize);
    }
}
    
</script>

<style scoped>
    .text-icon {
        margin-top: 2.5px;
    }

   .switch input[type="checkbox"]:not(:checked) + .slider {
      background-color: #3c3e42
   }
   input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(50%);
   }
    .slide-up-enter-active {
        transition: all 0.4s;
    }

    .slide-up-enter {
        transform: translateY(-100%);
        opacity: 0;
    }

    .slide-up-leave-to {
        transform: translateY(-100%);
        opacity: 0;
    }

    .ajusteBtn {
      margin-top: 32px;
   }

   .container_marker input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.container_marker {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 20px;
  user-select: none;
  border-radius: 50%;
  background-color: rgb(78, 78, 78);
}

/* Create a custom checkbox */
.checkmark {
  position: relative;
  top: 0;
  left: 0;
  height: 1em;
  width: 1em;
  transition: .3s;
  transform: scale(0);
  border-radius: 50%;
}

/* When the checkbox is checked, add a blue background */
.container_marker input:checked ~ .checkmark {
  background-color: #2096c5;
  transform: scale(1);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container_marker input:checked ~ .checkmark:after {
  display: block;
}

.container_marker input:checked ~ .celebrate {
  display: block;
}

/* Style the checkmark/indicator */
.container_marker .checkmark:after {
  left: 7px;
  top: 0.25em;
  width: 0.30em;
  height: 0.5em;
  border: solid rgb(255, 255, 255);
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
}

.container_marker .celebrate {
  position: absolute;
  transform-origin: center;
  animation: kfr-celebrate .4s;
  animation-fill-mode: forwards;
  display: none;
  stroke: #0392CF;
}

@keyframes kfr-celebrate {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: scale(1.2);
    opacity: 0;
    display: none;
  }
}


</style>